export default {
	bookABox: 'Rezerwacja boksu',
	chooseABox: 'Wybierz boks',
	stock: 'Magazyn',
	address: 'Adres',
	aip: 'kod pocztowy',
	selectStock: 'Sprawdź lokalizację',
	boxesAvailable: 'Dostępne boksy',
	totalBoxesNumberAtStock: 'Łącznie boksów w magazynie',
	sizes: 'Rozmiary',
	contractDuration: 'Czas trwania umowy',
	paymentFrequency: 'Okres rozliczeniowy',
	payRarePayLess: 'Im dłuższy okres rozliczeniowy - tym mniejszy czynsz!',
	payRareHelpBlock: 'Im dłuższy okres rozliczeniowy - tym większa zniżka!',
	totalToPay: 'Razem do zapłaty',
	includedInsurance: 'z ubezpieczeniem',
	inclVAT: 'brutto',
	notInclVAT: 'netto',
	toBookABox: 'Aby zarezerwować boks prosimy',
	authorize: 'Autoryzacja',
	iAgree: 'Naciskając Potwierdzam, akceptujesz poniższe dokumenty:',
	contractAgreementDoc: 'Umowa najmu (do wglądu)',
	stockRoutine: 'Regulamin Magazynu',
	privacyPolicy: 'Polityka prywatności',
	companyRules: 'Regulamin',
	contractTerms: 'Ogólne warunki najmu',
	notAvailable: 'Niedostępny',
	step1SelectTheSizeOfTheBox: 'Krok 1. Wybierz rozmiar boksu',
	step2SelectTheSizeOfTheBox: 'Krok 2. Wybierz rozmiar boksu',
	step3SelectABoxOnTheMap: 'Krok 3. Wybierz boks na mapie',
	month: 'miesiąc',
	week: 'tydzień',
	forWholePeriod: 'Razem',
	saveAmount: 'Zapisz',
	discount: 'Zniżka',
	cancel: 'Anulowanie rezerwacji',
	areYouSureToCancelReservation: 'Czy na pewno chcesz anulować rezerwację ?',
	insuranceAmount: (amount) => `Z naszym podstawowym ubezpieczeniem Twoje mienie jest ubezpieczone na ${amount} zł`,
	reserveWithRequiredPayment: 'Zarezerwuj z opłatą',
	reserveWithPayPal: 'Zarezerwuj z PayPal',
	reserveViaBankTransfer: 'Zarezerwuj przez przelew bankowy',
	iHaveReadDocsAndAgree: 'Zapoznałem się z poniższymi aneksami do umowy i akceptuję je w całości.',
	sizesMeta: {
		s: `Zmieścisz tutaj: <br />
		&#183; 40-200 kartonów lub<br />
		&#183; 2-8 regałów, lub<br />
		&#183; do 4 palet, lub<br />
		&#183; wyposażenie z pomieszczenia o wielkości do 35 m2<br /> <br />
		Wybierz tę opcję np. do przechowania rzeczy sezonowych czy pamiątek rodzinnych albo małego, firmowego archiwum.
		`,
		m: `
		Zmieścisz tutaj:<br />
			&#183; 210-300 kartonów lub<br />
			&#183; 9- 14 regałów, lub<br />
			&#183; do 7 palet, lub<br />
			&#183; wyposażenie z pomieszczenia o wielkości do 50 m2<br /> <br />
		Sprawdzi się np. w trakcie remontu całego mieszkania czy biura lub przeprowadzki, a także w przypadku niedużego sklepu internetowego.
		`,
		l: `
		Zmieścisz tutaj: <br />
		&#183; 320-1020 kartonów lub <br />
		&#183; 15 - 35 regałów, lub <br />
		&#183; do 18 palet, lub <br />
		&#183; wyposażenie z pomieszczenia o wielkości do 80 m2 <br /> <br />
		Idealne rozwiązanie dla małych i średnich firm oraz kiedy opróżniasz ponad 100-metrowy budynek.
		`,
		xl: `
		Zmieścisz tutaj: <br />
		&#183; 700-1000 kartonów lub <br />
		&#183; 10-15 regałów, lub <br />
		&#183; 15-20 palet, lub <br />
		&#183; wyposażenie z pomieszczenia o wielkości ok. 100 m2 <br /> <br />
		To już naprawdę pokaźna przestrzeń do przechowywania. Wybierz tę opcję, jeśli potrzebujesz magazynu dla swojego biznesu.
		`,
	},
	tariffs: {
		basic: 'Taryfa obowiązuje przy podpisaniu umowy na czas nieokreślony z 21-dniowym terminem wypowiedzenia oraz przy zawarciu umowy na czas określony krótszy niż 6 miesięcy',
		smart: 'Średnia kwota miesieczna przy podpisaniu umowy na czas określony na okres od 6 do 11 miesięcy. Zniżka wysokości 30% zostaje naliczona na 6 miesiąc.',
		max: 'Średnia kwota miesieczna przy podpisaniu umowy na czas określony na okres 12 miesięcy. Zniżka wysokości 65% zostaje naliczona na 12 miesiąc.',
		week: 'Taryfa obowiązuje przy podpisaniu umowy z tygodniowym okresem rozliczeniowym.'
	},
	insuranceCoverage: 'Ubezpieczenie do kwoty',
	englishWordOr: 'lub',
	yourChoice: 'Twój wybór',
	freeBoxesOfTheRightSize: 'Wolne boksy w odpowiednim rozmiarze',
	occupiedBoxes: 'Zajęte boksy',
	continue: 'Kontynuj',
	reservations: 'Rezerwacje',
	bookWithoutPayment: 'Rezerwuj bez płatności',
	bookAndPay: 'Zarezerwuj i zapłać',
	choiceOfArrivalDateTitle: 'Data wprowadzenia się',
	choiceOfArrivalDateText: 'Kiedy potrzebujesz swojego boksu',
	choiceOfArrivalDatePlaceholder: 'Wybierz datę',
	choiceOfDepartureDateTitle: 'Data wyjazdu',
	choiceOfDepartureDatePlaceholder: 'Wybierz datę',
	successTitle: ['Gratulacje!', 'Box został pomyślnie zarezerwowany.'],
	successText: 'Proszę sprawdzić swój e-mail i podpisać umowę. Może on znajdować się w  folderze spamu. Box będzie dostępny od dnia podpisania umowy po opłaceniu faktury..',
	selectUser: 'Wybierz użytkownika',
	user: 'Użytkownik',
	docsAgreement: 'Regulamin',
	payment: 'Rezerwacja',
	openEndedContractNote: 'Jest to umowa na czas nieokreślony, która będzie trwała do momentu jej anulowania. Wybrany termin reprezentuje Twoją opcję anulowania.',
	back: 'Powrót',
	close: 'Zamknij',
	insuranceWillBeAdded: '+ubezpieczenie',
	automaticPaymentsText: 'Automatyczna płatność miesięczna',
	searchHeader: 'Przeszukaj tę mapę',
	cityOrStockName: 'Miasto lub magazyn',
	sendPhotos: 'Wyślij zdjęcie',
	uploadDocsPhoto: 'Prześlij zdjęcia dokumentów',
	bookingByTheAdministrator: 'Rezerwacja przez administratora jest zabroniona! Zaloguj się jako użytkownik.',
	chooseYourInsurance: 'Wybierz swoje ubezpieczenie',
	valueOfGoods: 'Wartość twoich rzeczy',
	oneEuroForFirstMonth: 'Pierwszy miesiąc za 1 euro',
	boxNumber: 'Numer boksu',
	minimalRentPeriodDescription: 'Minimalny okres wynajmu 7 dni',
	forTwoInitialMonths: 'Przez pierwsze dwa miesiące',
	forInitialServicePeriod: 'Pierwsza wpłata wraz ze zwrotnym depozytem oraz ubezpieczeniem',
	twoInitialMonthsInsuranceDescription: '',
	price: 'Cena',
	prices: 'Ceny',
	selectBoxSize: 'Wybierz boks',
	enterDataAndPayment: 'Zarezerwuj',
	bookingParams: 'Taryfa',
	reserveOrPay: 'Rezerwacja',
	andPayLater: 'Zapłać pózniej',
	payLaterDesctiption: 'Fakturę znajdziesz na swoim koncie',
	contactSource: 'Jak się o nas dowiedziałeś?',
	reasonForStorage: 'Powód przechowywania',
	areYouSureToCreateAContract: 'Czy jesteś pewien, że chcesz stworzyć umowę?',
	enterIntoContractExplanation: `Klikając "Wejdź do umowy" dokonasz utworzenia umowy.
		Otrzymasz link do podpisania umowy na swój e-mail oraz fakturę wstępną.
		Po opłaceniu faktury cały dostęp do magazynu i skrzynki zostanie Ci przyznany..`,
	reservationId: 'Identyfikator rezerwacji',
	expires: 'Rezerwacja wygasa',
	expired: 'Rezerwacja wygasła !',
	stockAddess: 'Adres magazynu',
	box: 'Boks',
	startRentDate: 'Data rozpoczęcia wynajmu',
	endRentDate: 'Data zakończenia wynajmu',
	initialPayment: 'Pierwsza wpłata wraz ze zwrotnym depozytem',
	enterIntoContract: 'Zawarcie umowy',
	details: 'Szczegóły',
	rentalCost: 'Koszt wynajmu netto',
	insurance: 'Kwota ubezpieczenia',
	deposit: 'Depozyt',
	vatAmount: 'VAT',
	mapAndList: 'Mapa & lista',
	map: 'Mapa',
	list: 'Lista',
	boxLeaseAgreement: 'Umowa najmu boksów z Rentabox LLC',
	selectOnMap: 'Wybierz na mapie',
	step3SelectABox: 'Krok 3. Wybierz boks',
	boxesFromAnotherCategory: 'Boksy z innej kategorii rozmiarów',
	reservationDescription: 'Rezerwacja jest bezpłatna. Aby uzyskać dostęp do swojego magazynu, odwiedź nasze biuro w terminie nie dłuższym niż 3 dni od dokonania rezerwacji lub zawrzyj umowę online samodzielnie, na swoim koncie klienta.',
	paymentFromSecondMonth: 'Opłata miesięczna od drugiego miesiąca',
	paymentFromSecondWeek: 'Opłata od drugiego tygodnia',
	specialMonthPaymentDescription: (specialMonth, discountPercent) => `Opłata za ${specialMonth} miesiąc ze zniżką ${discountPercent}%`,
	reservationWithoutDepartureDateDescription: 'Czas niokreślony, okres wypowiedzenia - 21 dni',
	readDocsAndAgree: () => 'Oświadczam, że zapoznałem się z umową najmu wraz z załącznikami i w pełni akceptuję wszystkie warunki.',
	cantPreview: (link) => `Nie można wyświetlić podglądu, pobierz <a href=${link}>dokument</a>`,
	getRoute: 'Uzyskać trasę',
	externalBoxDescription: (link) => `Wybrany boks wymaga odbioru klucza z recepcji przed wprowadzeniem się ( <a href=${link}>SPRAWDŹ GODZINY OTWARCIA</a> )`,
	viewThisbox: 'Zobacz magazyn w tym rozmiarze ->',
	carLimitsWarning: `
		<span style="font-size: 18px"><b>Uwaga!</b></span> <br>
		Wjazd na teren obiektu wyłącznie dla samochodów <br><b>do 3,05m</b>! <br>
		Możliwość wjazdu wyższych samochodów tylko w godzinach pracy biura <br>
		<span style="font-size: 16px">PN-PT: 08.00-19.00 </span> <br>
		<span style="font-size: 16px">SOB: 10.00-15.00 </span><br>
	`
};
